import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {
    Box,
    Button,
    Checkbox,
    Flex,
    Input,
    NumberDecrementStepper,
    NumberIncrementStepper,
    NumberInput,
    NumberInputField,
    NumberInputStepper,
    Select,
    Text,
    Textarea
} from "@chakra-ui/react";
import ScrooToTop from "../component/ScrooToTop";
import './ItineraryLab.css'
import {v4 as uuidv4} from "uuid";
import axios from "axios";
import ENV from "../ENV.json";
import Popup from "../component/Popup";
import FileUploader from "../component/FileUploader";
import {useHistory} from "react-router-dom";
import {reactLocalStorage} from "reactjs-localstorage";
import {DeleteIcon} from "@chakra-ui/icons";


const ItineraryLab = (props) => {
    const formatKM = (val) => val + ' KM'
    const formatDay = (val) => val + ' g'
    const formatHour = (val) => val + ' h'
    const formatMinute = (val) => val + ' m'
    const formatPercentage = (val) => val + ' %'
    const parse = (val) => val.replace(/^\$/, '')

    const history = useHistory();
    const [name, setName] = useState('');
    const [lengthKM, setLengthKM] = useState(0); //Lunghezza & Lunghezza in KM
    //ID delle località di partenza/destinazione

    const [departure, setDeparture] = useState(70001);
    const [noteDeparture, setNoteDeparture] = useState('');
    const [destination, setDestination] = useState(70001);
    const [noteDestination, setNoteDestination] = useState('');

    const [isVerticalSignal, setIsVerticalSignal] = useState(false);
    const [isHorizontalSignal, setIsHorizontalSignal] = useState(false);
    const [isInformativeSignal, setIsInformativeSignal] = useState(false);
    const [critical, setCritical] = useState('');
    const [linkWeb, setLinkWeb] = useState('');
    const [addedLink, setAddedLink] = useState([])

    //Territori comunali attraversati
    const [comuniDownloading, setComuniDownloading] = useState(true);

    const [selectedComune, setSelectedComune] = useState("70001")
    const [listOfComuni, setListOfComuni] = useState([]);
    const [listOfSelectedComuni, setListOfSelectedComuni] = useState([]);

    //Durata dell'evento gg - ore - min
    const [durationDays, setDurationDays] = useState(0);
    const [durationHour, setDurationHour] = useState(0);
    const [durationMinutes, setDurationMinutes] = useState(0);


    const [difficulty, setDifficulty] = useState('T - Turismo');

    const [naturalPerc, setNaturalPerc] = useState(0);
    const [carrareccePerc, setCarrareccePerc] = useState(0);
    const [asfaltoPerc, setAsfaltoPerc] = useState(0);

    const [totPos, setTotPos] = useState(0);
    const [totNeg, setTotNeg] = useState(0);

    const [maxMtSea, setMaxMtSea] = useState(0);
    const [minMtSea, setMinMtSea] = useState(0);

    const [maxPendenzaPos, setMaxPendenzaPos] = useState(0);
    const [maxPendenzaNeg, setMaxPendenzaNeg] = useState(0);

    const [description, setDescription] = useState('');
    const [note, setNote] = useState('');

    //GeoJson file
    const [geoJson, setGeoJson] = useState(null);

    const segnaletics = useMemo(() => [{
        id: 0,
        title: "Presenza di segnaletica orizzontale",
        value: isHorizontalSignal,
        update: setIsHorizontalSignal
    }, {
        id: 1,
        title: "Presenza di segnaletica verticale",
        value: isVerticalSignal,
        update: setIsVerticalSignal
    }, {
        id: 2,
        title: "Presenza di segnaletica informativa",
        value: isInformativeSignal,
        update: setIsInformativeSignal
    }], [isHorizontalSignal, isVerticalSignal, isInformativeSignal])

    const [modalOpen, setModalOpen] = useState(false);
    const [popupData, setPopupData] = useState({});

    useEffect(() => {

        const User = reactLocalStorage.getObject('User');
        console.log("Abbiamo trovato un User -> " + User);
        if (!User) history.push('/');

        setComuniDownloading(true);
        axios.get(`${ENV[ENV.ENV_STATE].baseUrl}/comuni`)
            .then(function (response) {
                if (response?.data?.status) {
                    setListOfComuni(response?.data?.rows)
                } else {
                    setPopupData(response?.data);
                    setModalOpen(true);
                }
                setComuniDownloading(false);
            })
            .catch(function (error) {
                setPopupData({
                    status: false,
                    title: "Errore imprevisto",
                    message: "Non è stato possibile caricare i comuni. Ricarica la pagina!"
                })
                setModalOpen(true);
            })
            .then(function (response) {
                setComuniDownloading(false);
            });
    }, []);

    const itineraryObject = useMemo(() => {
        return ({
            name,
            lengthKM,
            departure,
            noteDeparture,
            destination,
            noteDestination,
            isVerticalSignal,
            isHorizontalSignal,
            isInformativeSignal,
            critical,
            addedLink,
            listOfSelectedComuni,
            durationDays,
            durationHour,
            durationMinutes,
            difficulty,
            naturalPerc,
            carrareccePerc,
            asfaltoPerc,
            totPos,
            totNeg,
            maxMtSea,
            minMtSea,
            maxPendenzaPos,
            maxPendenzaNeg,
            geoJson,
            description,
            note
        })
    }, [name, lengthKM, departure, noteDeparture, destination, noteDestination, isVerticalSignal, isHorizontalSignal, isInformativeSignal,
        critical, addedLink, listOfSelectedComuni, durationDays, durationHour, durationMinutes,
        difficulty, naturalPerc, carrareccePerc, asfaltoPerc, totPos, totNeg, maxMtSea, minMtSea, maxPendenzaPos,
        maxPendenzaNeg, geoJson, description, note]);

    const printItineraryObj = useCallback(() => {
        console.log(itineraryObject);
    }, [itineraryObject]);

    return (
        <Box {...props?.pageProps}>
            <Text className='textSection'>Scheda rilievo percorsi</Text>
            <Flex className={"poi_container"}>
                <Text className='textSection'>Informazioni generali</Text>
                {/*NOME ITINERARIO E LUNGHEZZA KM*/}
                <Flex justifyContent={"space-between"} direction={"row"}>
                    {/* QUI INSERISCI IL NOME DELL'ITINERARIO */}
                    <Box flex={1}>
                        <Text style={{marginRight: '10px'}}>Nome del percorso</Text>
                        <Text fontSize={"12px"}
                              color={"brown"}>{`Limite massimo di 200 caratteri (${name?.length || "0"}/200)`}</Text>
                        <Input isInvalid={name?.length === 0} value={name}
                               onChange={(event) => setName(event?.target?.value)}/>
                    </Box>
                    <div style={{width: "50px"}}/>
                    {/* LUNGHEZZA TOTALE IN KM */}
                    <Box flex={1}>
                        <Text style={{marginRight: '10px'}}>Lunghezza tot km.</Text>
                        <Text fontSize={"12px"}
                              color={"brown"}>{`Solo numeri`}</Text>
                        <NumberInput
                            onChange={(valueString) => setLengthKM(parseInt(parse(valueString)))}
                            value={formatKM(lengthKM)}
                            min={0}
                        >
                            <NumberInputField/>
                            <NumberInputStepper>
                                <NumberIncrementStepper/>
                                <NumberDecrementStepper/>
                            </NumberInputStepper>
                        </NumberInput>
                    </Box>
                </Flex>


                {/*LOCALITA' PARTENZA | LOCALITA ARRIVO*/}
                <Text className='textSection'>Informazioni su partenza e arrivo</Text>
                <Flex justifyContent={"space-between"} direction={"row"}>
                    {
                        [0, 1].map(e => {
                            return (
                                <Box key={e} className={e === 0 ? 'left_city_select' : 'right_city_select'} flex={1}>
                                    <Text
                                        style={{marginRight: '10px'}}>{`Località di ${e === 0 ? "partenza" : "arrivo"}`}</Text>
                                    <Select
                                        isRequired value={e === 0 ? departure : destination}
                                        size='md'
                                        onChange={(event) => {
                                            console.log("E' stato scelto " + event?.target?.value);
                                            e === 0 ? setDeparture(parseInt(event?.target?.value)) : setDestination(parseInt(event?.target?.value))
                                        }}
                                    >
                                        {
                                            listOfComuni.map(e => {
                                                return (
                                                    <option key={e?.PRO_COM} value={e?.PRO_COM}>
                                                        {e?.name}
                                                    </option>
                                                );
                                            })
                                        }
                                    </Select>
                                    <div style={{height: '10px'}}/>
                                    <Text style={{marginRight: '10px'}}>
                                        Aggiungi una nota
                                    </Text>
                                    <Textarea
                                        placeholder={"Partiamo dalla rotonda ..."}
                                        value={e === 0 ? noteDeparture : noteDestination}
                                        onChange={(event) => e === 0 ?
                                            setNoteDeparture(event?.target?.value)
                                            :
                                            setNoteDestination(event?.target?.value)}
                                    />
                                </Box>
                            )
                        })
                    }
                </Flex>

                {/*SEGNALETICA ORIZZONATALE | VERTICALE | INFORMATIVA*/}
                <Text className='textSection'>Segnaletica</Text>
                {
                    segnaletics
                        ?.map(segn =>
                            <Checkbox key={segn?.id} colorScheme="orange" isChecked={segn?.value}
                                      onChange={(event) => segn?.update(!segn?.value)}>
                                {segn?.title}
                            </Checkbox>
                        )
                }
                <Text style={{marginRight: '10px'}}>Criticità</Text>
                <Textarea
                    placeholder='Aggiungi delle criticità...'
                    value={critical}
                    onChange={(event) => setCritical(event?.target?.value)}/>

                {/*INFORMAZIONI SUI SITI WEB*/}
                <Text style={{marginRight: '10px'}}>Lista dei siti web</Text>
                <Flex flexDirection="row" gap="10px">
                    <Input placeholder={'Aggiungi un link web... '} value={linkWeb} onChange={(event) => setLinkWeb(event?.target?.value)}/>
                    <Button
                        disabled={linkWeb?.length === 0}
                        onClick={() => {
                            if (linkWeb?.length === 0) return;
                            setAddedLink([...addedLink, linkWeb])
                            setLinkWeb('')
                        }}
                    >
                        Aggiungi link web
                    </Button>
                </Flex>
                <Box className='list_page'>
                    {
                        addedLink?.map(link => {
                            return (
                                <Flex key={uuidv4()} className='link_record' flexDirection='row' alignItems='center'
                                      justifyContent='space-between'>
                                    <Text>{link}</Text>
                                    <Button leftIcon={<DeleteIcon/>}
                                            onClick={() => setAddedLink(addedLink.filter(e => e !== link))}>
                                        ELIMINA
                                    </Button>
                                </Flex>
                            )
                        })
                    }
                </Box>

                {/*INFORMAZIONI TECNICHE DI PERCORSO*/}
                <Text className='textSection'>Informazioni tecniche di percorso</Text>

                {/* COMUNI ATTRAVERSATI DALL'ITINERARIO */}
                <Text style={{marginRight: '10px'}}>Territori comunali attraversati</Text>
                <Flex flexDirection="row" gap="10px">
                    <Select
                        isRequired
                        value={selectedComune}
                        size='md'
                        onChange={(event) => {
                            console.log("Abbiamo scelto un comune " + event?.target?.value)
                            setSelectedComune(event?.target?.value)
                        }}
                    >
                        {
                            listOfComuni?.map(e => {
                                return (
                                    <option key={e?.PRO_COM} value={e?.PRO_COM}>
                                        {e?.name}
                                    </option>
                                );
                            })
                        }
                    </Select>
                    <Button
                        onClick={() => {
                            if(!listOfSelectedComuni.includes(selectedComune))
                                setListOfSelectedComuni([...listOfSelectedComuni, selectedComune])
                            else{
                                setPopupData({
                                    status: false,
                                    title: "Comune non aggiunto",
                                    message: "Hai aggiunto già il comune selezionato"
                                })
                                setModalOpen(true);
                            }
                        }}
                    >
                        Aggiungi comune
                    </Button>
                </Flex>

                <Box className='list_page'>
                    {
                        listOfSelectedComuni?.map(comune => {
                            const nameComune = listOfComuni.find(c => c?.PRO_COM == comune)?.name
                            return (
                                <Flex key={uuidv4()} className='link_record' flexDirection='row' alignItems='center'
                                      justifyContent='space-between'>
                                    <Text>{`${comune} - ${nameComune || '?'}`}</Text>
                                    <Button
                                        leftIcon={<DeleteIcon/>}
                                        onClick={() => setListOfSelectedComuni(listOfSelectedComuni.filter(com => com != comune))}>
                                        ELIMINA
                                    </Button>
                                </Flex>
                            )
                        })
                    }
                </Box>

                {/*Durata dell'itinerario*/}
                <Text style={{marginRight: '10px'}}>Durata del percorso</Text>
                <Flex flexDirection='row'>
                    <Flex flexDirection='column'>
                        <Text style={{marginRight: '10px'}}>Giorni</Text>
                        <NumberInput onChange={(valueString) => setDurationDays(parseInt(parse(valueString)))}
                                     value={formatDay(durationDays)} min={0}>
                            <NumberInputField/>
                            <NumberInputStepper>
                                <NumberIncrementStepper/><NumberDecrementStepper/>
                            </NumberInputStepper>
                        </NumberInput>
                    </Flex>
                    <Flex flexDirection='column'>
                        <Text style={{marginRight: '10px'}}>Ore</Text>
                        <NumberInput
                            onChange={(valueString) => setDurationHour(parseInt(parse(valueString)))}
                            value={formatHour(durationHour)} min={0} max={23}>
                            <NumberInputField/>
                            <NumberInputStepper>
                                <NumberIncrementStepper/><NumberDecrementStepper/>
                            </NumberInputStepper>
                        </NumberInput>
                    </Flex>
                    <Flex flexDirection='column'>
                        <Text style={{marginRight: '10px'}}>Minuti</Text>
                        <NumberInput
                            onChange={(valueString) => setDurationMinutes(parseInt(parse(valueString)))}
                            value={formatMinute(durationMinutes)} min={0} max={59}>
                            <NumberInputField/>
                            <NumberInputStepper>
                                <NumberIncrementStepper/><NumberDecrementStepper/>
                            </NumberInputStepper>
                        </NumberInput>
                    </Flex>
                </Flex>

                {/* DIFFICOLTA' */}
                <Text style={{marginRight: '10px'}}>Difficoltà del percorso</Text>
                <Select
                    isRequired
                    value={difficulty}
                    size='md'
                    onChange={(event) => {
                        setDifficulty(event?.target?.value)
                    }}
                >
                    {
                        ['T - Turismo', 'E - Escursionistico', 'EE - Escursionistico Esperto', 'EEA - Escursionistico Esperto con Attrezzatura'].map(dif =>
                            <option key={dif} value={dif}>
                                {dif}
                            </option>
                        )
                    }
                </Select>

                {/* PERCENTUALE NATURALE | CARRARECCE | ASFALTO */}
                <Text style={{marginRight: '10px'}}>% Naturale</Text>
                <NumberInput
                    onChange={(valueString) => setNaturalPerc(parseInt(parse(valueString)))}
                    value={formatPercentage(naturalPerc)} min={0} max={100}>
                    <NumberInputField/>
                    <NumberInputStepper>
                        <NumberIncrementStepper/><NumberDecrementStepper/>
                    </NumberInputStepper>
                </NumberInput>

                <Text style={{marginRight: '10px'}}>% Carrarecce - piste forestali</Text>
                <NumberInput
                    onChange={(valueString) => setCarrareccePerc(parseInt(parse(valueString)))}
                    value={formatPercentage(carrareccePerc)} min={0} max={100}>
                    <NumberInputField/>
                    <NumberInputStepper>
                        <NumberIncrementStepper/><NumberDecrementStepper/>
                    </NumberInputStepper>
                </NumberInput>

                <Text style={{marginRight: '10px'}}>% Asfaltato</Text>
                <NumberInput
                    onChange={(valueString) => setAsfaltoPerc(parseInt(parse(valueString)))}
                    value={formatPercentage(asfaltoPerc)} min={0} max={100}>
                    <NumberInputField/>
                    <NumberInputStepper>
                        <NumberIncrementStepper/><NumberDecrementStepper/>
                    </NumberInputStepper>
                </NumberInput>


                {/* INFORMAZIONI SUI DISLIVELLI */}
                <Text className='textSection'>Info sui dislivelli</Text>

                <Text style={{marginRight: '10px'}}>Tot positivo (altitudine della polilinea)</Text>
                <NumberInput
                    onChange={(valueString) => setTotPos(parseInt(parse(valueString)))}
                    value={formatMinute(totPos)} min={0}>
                    <NumberInputField/>
                    <NumberInputStepper>
                        <NumberIncrementStepper/><NumberDecrementStepper/>
                    </NumberInputStepper>
                </NumberInput>

                <Text style={{marginRight: '10px'}}>Tot negativo (altitudine della polilinea)</Text>
                <NumberInput
                    onChange={(valueString) => setTotNeg(parseInt(parse(valueString)))}
                    value={formatMinute(totNeg)} min={0}>
                    <NumberInputField/>
                    <NumberInputStepper>
                        <NumberIncrementStepper/><NumberDecrementStepper/>
                    </NumberInputStepper>
                </NumberInput>

                <Text style={{marginRight: '10px'}}>Max mt s.l.m.</Text>
                <NumberInput
                    isInvalid={maxMtSea < minMtSea}
                    onChange={(valueString) => setMaxMtSea(parseInt(parse(valueString)))}
                    value={formatMinute(maxMtSea)} min={0}>
                    <NumberInputField/>
                    <NumberInputStepper>
                        <NumberIncrementStepper/><NumberDecrementStepper/>
                    </NumberInputStepper>
                </NumberInput>

                <Text style={{marginRight: '10px'}}>Min mt s.l.m.</Text>
                <NumberInput
                    isInvalid={maxMtSea < minMtSea}
                    onChange={(valueString) => setMinMtSea(parseInt(parse(valueString)))}
                    value={formatMinute(minMtSea)} min={0}>
                    <NumberInputField/>
                    <NumberInputStepper>
                        <NumberIncrementStepper/><NumberDecrementStepper/>
                    </NumberInputStepper>
                </NumberInput>

                <Text style={{marginRight: '10px'}}>% Max pendenza POSITIVA</Text>
                <NumberInput
                    onChange={(valueString) => setMaxPendenzaPos(parseInt(parse(valueString)))}
                    value={formatPercentage(maxPendenzaPos)} min={0} max={100}>
                    <NumberInputField/>
                    <NumberInputStepper>
                        <NumberIncrementStepper/><NumberDecrementStepper/>
                    </NumberInputStepper>
                </NumberInput>

                <Text style={{marginRight: '10px'}}>% Max pendenza NEGATIVA</Text>
                <NumberInput
                    onChange={(valueString) => setMaxPendenzaNeg(parseInt(parse(valueString)))}
                    value={formatPercentage(maxPendenzaNeg)} min={0} max={100}>
                    <NumberInputField/>
                    <NumberInputStepper>
                        <NumberIncrementStepper/><NumberDecrementStepper/>
                    </NumberInputStepper>
                </NumberInput>

                <Text style={{marginRight: '10px'}}>Descrizione dell'itinerario</Text>
                <Textarea isInvalid={description?.length === 0}
                          value={description}
                          onChange={(event) => setDescription(event?.target?.value)}/>

                <Text style={{marginRight: '10px'}}>Note</Text>
                <Textarea
                          value={note}
                          onChange={(event) => setNote(event?.target?.value)}/>

                <FileUploader
                    onWrongFiles={() => {
                        setPopupData({
                            status: false,
                            title: "File non concesso",
                            message: "Bisogna caricare solo geojson"
                        })
                        setModalOpen(true);
                    }}
                    onGeoJsonLoaded={(file) => {
                        setGeoJson(file)
                    }}
                />
                <Button onClick={printItineraryObj}>SALVA</Button>
            </Flex>
            <ScrooToTop/>
            <Popup isOpen={modalOpen} onClose={() => setModalOpen(false)} popupData={popupData}/>
        </Box>
    );
};

export default ItineraryLab;
